<template>
  <div class="contenedor">
    <div class="cabecera">
      <div>
        <img src="@/assets/userImg.png" alt="" class="img">
      </div>
      <h2 style="display: inline-block;float: left;margin-left: 10px;">{{ nombres }} {{ apellidos }}</h2>
      <h2 style="display: inline-block;float: right;margin-right: 10px;color: rgba(255, 195, 0, 1);">
        {{ cargo }}
      </h2>
    </div>
    <div class="contenido">
      <div class="borderCoffe bloque">     
           <table>
              <tr v-for="alimento in listaAlimentos" :key="alimento.id">
                <td> <img class="imgAlimento borderCoffe" :src="alimento.urlImagen" alt=""></td>
                <td>
                  <div> 
                    <h3>{{ alimento.alimento }}</h3>
                    </div>
                  <div>${{ alimento.precio }}</div>
                </td>
                <td><button class="camposForm">añadir</button></td>
              </tr>
           </table>
      </div>
      <div class="borderCoffe bloque">
      </div>
    </div>
  </div>
</template>

<script>
import { DarAlimentos } from '@/Apis/ApisAlimentos'
import {DarInfoUserLogin} from '@/Apis/ApisUsuarios.js'

export default {
  name: "HomeHome",
  data: () => ({
    nombres: "",
    apellidos: "",
    cargo: '',
    usuario: '',
    listaAlimentos: []
  }),
  created(){
    DarInfoUserLogin()
      .then(response => {
          console.log(response)
          this.nombres = response.nombres
          this.apellidos = response.apellidos
          this.usuario = response.usuario

        }
      )
    DarAlimentos()
      .then(response => {
        this.listaAlimentos = response
      })
    
  },
  methods: {
  }
}
</script>
<style scoped>
.contenedor{
  background-color: rgba(255, 250, 235, 1);
  
}
.cabecera{

  display: inline-block;
  color: white;
  width: 60%;
  background-color: rgba(37, 19, 3, 1);
  border-radius: 10px;
  margin-top: 20px;
  padding: 5px;
}
.img{
  display: inline-block;
  float: left;
  background-color: rgba(255, 250, 235, 1);
  padding: 5px;
  border-radius: 100%;
}

.borderCoffe{
  border-radius: 15px;
  border: 2px solid rgba(37, 19, 3, 1);
}
.bloque{
  display: inline-block;
  width: 45%;
  min-width: 300px;
  min-height: 500px;
  margin: 20px;
}
.camposForm{
  display: block;
  width: calc(100% - 60px);
  margin: 30px;
  font-size: 25px;
  border-radius: 5px;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-stretch: 700px;
}
.imgAlimento{
  margin: 5px;
  border-radius: 10px;
  width: 200px;        /* Puedes ajustar esto si quieres más grande */
  height: 200px;
  object-fit: cover;  /* Esto asegura que la imagen se recorte para ajustarse al cuadro */
  display: inline-block;
}

</style>
